import { render, staticRenderFns } from "./IpoResultFundsAccountsRow.vue?vue&type=template&id=1a5fbbe8&scoped=true"
import script from "./IpoResultFundsAccountsRow.vue?vue&type=script&lang=js"
export * from "./IpoResultFundsAccountsRow.vue?vue&type=script&lang=js"
import style0 from "./IpoResultFundsAccountsRow.vue?vue&type=style&index=0&id=1a5fbbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5fbbe8",
  null
  
)

export default component.exports